import React, { useEffect, useMemo, useState } from 'react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';

import { Layout } from 'antd';

import AppLoading from './components/plat/loading/loading';
import Header from './components/plat/header';
import AppLogin from './components/plat/login/Login';
import SafeLogin from './components/plat/login/safeLogin';
import SettlementEvidence from './components/plat/settlementEvidence';
import CrumbsNav from './components/plat/nav/crumbs';
import SliderNav from './components/plat/nav/slider';

import { RootRouter } from "./routes/Router";

import { isLogged, readLoginPath, readSiderWidth, writeLoginPath } from './utils/storage';
import { subscribeLogin, subscribeLogout, subscribeRedirectSingup, subscribeSignup, subscribeSliderWidth } from './utils/ps';

import 'antd/dist/antd.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import './style/App.less';


const { Content, Sider } = Layout;

const App = ()=> {

  const loginPath = useMemo(()=> readLoginPath(), []);

  const [view, setView] = useState('view')
  const [siderWidth, setSiderWidth] = useState(()=> readSiderWidth() + 'px')

  useEffect(()=> {

    subscribeSliderWidth((value)=> {
      setSiderWidth(value)
    })

    subscribeLogin(()=> {
      setView('intoApp')
    })

    subscribeLogout(()=> {
      setView('login')
    })
   
    subscribeRedirectSingup(()=> {
      setView('register')
    })

    subscribeSignup(()=> {
      setView('login')
    })

    writeLoginPath(window.location.pathname)

    // return ()=> {
    //   unsubscribeLogin()
    //   unsubscribeSignup()
    //   unsubscribeLogout()
    //   unsubscribeSliderWidth()
    //   unsubscribeRedirectSignup()
    // }
  }, [])

  // 已登录
  let children = null
  if (view == 'intoApp' || isLogged()) {
      children = (
        <>
          <Header />
          <Layout hasSider className="content">
            <Sider width={siderWidth} collapsedWidth={0} theme='light'>
              <SliderNav onResize={({ width })=> setSiderWidth(`${width}px`)}/>
              {/* <MenuNav getValue={handleWidth} getMouseUpVal={handleWidth}/> */}
            </Sider>
            <Content style={{width: `calc(100vw - ${siderWidth})`}}>
              <CrumbsNav/>
              <RootRouter/>
            </Content>
          </Layout>
        </>
      )
  } else {
      children = (
        <Switch>
          <Route exact path="/login" component={AppLogin} />
          <Route exact path="/settlementLg" component={SettlementEvidence} />
          {/* <Route exact path="/register" component={AppRegister} /> */}
          <Route exact path="/safeLogin" component={SafeLogin} />
          <Redirect exact={view == 'intoApp'} from={'/'} to={{ pathname: `${loginPath == '/safeLogin' ? '/safeLogin' : '/login'}` }} />
        </Switch>
      )
  }

  return (
    <Router>
      <Layout className="app">
        <AppLoading />
        <Layout className="omz-fit">{children}</Layout>
      </Layout>
    </Router>
  )
}

export default App